import React, { Component, PropTypes } from 'react';
import * as Actions from '../actions';
import { view as MyCarousel } from '../../../Component/MyCarousel';
import { view as BlogListTimeLine } from '../../../Component/BlogListTimeLine';
import { Layout, Menu, Icon, Modal, Input, BackTop } from 'antd';
import './home.css';
// import Axios from 'axios';
import crypto from 'crypto';
// import qs from 'qs';

const { Header, Sider, Content } = Layout;
const token = '28ec34c42b875e9782afe7b440543ff4';
const data = {
  uid: '64b2f11cc06bf1973c0dfa1d',
  price: 0.01,
  istype: 1,
  notify_url: 'http://daiyililvshi.com/',
  return_url: 'http://daiyililvshi.com/',
  orderid: Math.round(Math.random()* 10000000),
  orderuid: Math.round(Math.random()* 10000000000),
  goodsname: 'good',
};
const dataString =
  data.goodsname +
  data.istype +
  data.notify_url +
  data.orderid +
  data.orderuid +
  data.price +
  data.return_url +
  token +
  data.uid;
const md5 = crypto.createHash('md5');
const key = md5.update(dataString).digest('hex');
class Home extends Component {
  constructor(props, context) {
    super(props, context);

    this.getOwnState = this.getOwnState.bind(this);
    this.onChange = this.onChange.bind(this);
    this.state = this.getOwnState();
    this.toggle = this.toggle.bind(this);
    this.showLoginModal = this.showLoginModal.bind(this);
    this.LoginSubmit = this.LoginSubmit.bind(this);
    this.LoginCancel = this.LoginCancel.bind(this);
    this.state = this.getOwnState();
  }

  getOwnState() {
    return this.context.store.getState().home;
  }

  onChange() {
    this.setState(this.getOwnState());
  }

  componentDidMount() {
    this.context.store.subscribe(this.onChange);
  }

  toggle() {
    this.context.store.dispatch(Actions.ToggleSider(!this.context.store.getState().home.collapsed));
  }

  showLoginModal() {
    this.context.store.dispatch(Actions.LoginModal());
  }

  LoginSubmit() {
    this.context.store.dispatch(Actions.LoginSubmit());
    setTimeout(() => {
      this.context.store.dispatch(Actions.LoginClosed());
    }, 2000);
  }

  LoginCancel() {
    this.context.store.dispatch(Actions.LoginClosed());
  }

  // pay() {
  //   const token = '28ec34c42b875e9782afe7b440543ff4';
  //   const data = {
  //     uid: '64b2f11cc06bf1973c0dfa1d',
  //     price: 0.01,
  //     istype: 1,
  //     notify_url: 'https://www.google.com',
  //     return_url: 'https://www.google.com',
  //     orderid: '123456789',
  //     orderuid: '123456789',
  //     goodsname: 'know',
  //   };
  //   const dataString =
  //     data.goodsname +
  //     data.istype +
  //     data.notify_url +
  //     data.orderid +
  //     data.orderuid +
  //     data.price +
  //     data.return_url +
  //     token +
  //     data.uid;
  //   const md5 = crypto.createHash('md5');
  //   const key = md5.update(dataString).digest('hex');
  //   data.key = key;
  //   let formData = new FormData();
  //   Object.keys(data).forEach(key => {
  //     formData.append(key, data[key]);
  //   });
  //   console.log(formData.get('key'));
  //   Axios({
  //     method: 'POST',
  //     url: 'https://pay.bearsoftware.net.cn/',
  //     data: qs.stringify(data),
  //     // formData,
  //     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  //   }).then(data => {
  //   });
  // }

  submit() {
    console.log(key);
    console.log(document.getElementById('form').ser);
    document.getElementById('form').submit();
  }

  render() {
    return (
      <Layout style={{ height: '100%' }}>
        <Sider trigger={null} collapsible collapsed={this.state.collapsed}>
          <div className="logo" style={{ textAlign: 'center' }}>
            <h2
              className={this.state.collapsed ? '' : 'show'}
              style={{ height: '32px', lineHeight: '32px', color: '#fff', opacity: 0 }}
            >
              My Blog
            </h2>
          </div>
          <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
            <Menu.Item key="1">
              <Icon type="home" />
              <span>主页</span>
            </Menu.Item>
            <Menu.Item key="2">
              <Icon type="database" />
              <span>分类</span>
            </Menu.Item>
            <Menu.Item key="3">
              <Icon type="tag-o" />
              <span>标签</span>
            </Menu.Item>
            <Menu.Item key="4" >
              <Icon type="user" />
              <span onClick={this.submit}>付款</span>
            </Menu.Item>
          </Menu>
        </Sider>
        <form id="form" style={{ display: 'none' }} action="https://pay.bearsoftware.net.cn/" method="post">
          <input type="text" name="uid" value={data.uid} />
          <input type="number" name="price" value={data.price} />
          <input type="number" name="istype" value={data.istype} />
          <input type="text" name="notify_url" value={data.notify_url} />
          <input type="text" name="return_url" value={data.return_url} />
          <input type="text" name="orderid" value={data.orderid} />
          <input type="text" name="orderuid" value={data.orderuid} />
          <input type="text" name="goodsname" value={data.goodsname} />
          <input type="text" name="key" value={key} />
        </form>
        <Layout id="content">
          <Header style={{ background: '#fff', padding: 0 }}>
            <Icon className="trigger" type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'} onClick={this.toggle} />
            {/* <Button type="primary" ghost className="login-button"
                                style={this.state.collapsed ? {
                                    height: '32px',
                                    width: '60px',
                                    marginLeft: '1085px'
                                } : {
                                    height: '32px',
                                    width: '60px',
                                    marginLeft: '950px'
                                }} onClick={this.showLoginModal}>登录</Button>
                        <Button type="primary" ghost
                                className="registerButton"
                                style={{
                                    height: '32px',
                                    width: '60px',
                                    marginLeft: '10px'
                                }}>注册</Button>*/}
          </Header>
          <MyCarousel />
          <Content
            style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 1480, position: 'relative' }}
          >
            <BlogListTimeLine />
          </Content>
        </Layout>
        <BackTop target={() => document.getElementById('content')} />
        <div>
          <Modal
            title="登录"
            visible={this.state.modal.visible}
            onOk={this.LoginSubmit}
            confirmLoading={this.state.modal.confirmLoading}
            onCancel={this.LoginCancel}
            width="300px"
          >
            <Input className="ant-input username" type="text" placeholder="请输入用户名" />
            <Input className="ant-input password" type="password" placeholder="请输入密码" />
          </Modal>
        </div>
      </Layout>
    );
  }
}

Home.contextTypes = {
  store: PropTypes.object,
};

export default Home;



// WEBPACK FOOTER //
// ./src/Pages/home/views/home.js